import {
  Avatar,
  Card,
  CardContent,
  Chip,
  Icon,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TextField,
  Typography,
  Button
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Search } from "@material-ui/icons";
import GridItem from "components/Grid/GridItem.jsx";
import EnhancedTableHead from "components/Table/EnhancedTableHead.jsx";
import React from "react";

const FnaHistoryContainer = props => {
  return (
    <Grid container>
      <GridItem xs={12} sm={12} md={10} style={{flexBasis: "100%", maxWidth: "100%", margin: 'auto' }}>
        <Card>
          <CardContent>
            <Typography variant="headline" className="centerCell">
              {props.clientName ? `${props.clientName}'s FNAs` : "Manage FNAs"}
            </Typography>
            {props.assistantActive ? (
              <Typography variant="caption" className="centerCell" gutterBottom>
                {props.brokerName}
              </Typography>
            ) : null}
            <div
              style={{
                borderBottom: "1px solid #cccccc69",
                margin: "5px auto",
                width: "25%",
                marginBottom: "20px"
              }}
            />

            <Paper style={{ overflowX: "auto" }}>
              <Grid container>
                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={3}
                  style={{ margin: "25px auto 0px auto" }}
                >
                  <Chip
                    avatar={
                      <Avatar
                        style={{
                          backgroundColor: "#6c5cab",
                          color: "white"
                        }}
                      >
                        <Icon>add</Icon>
                      </Avatar>
                    }
                    className="customChip"
                    variant="outlined"
                    label={
                      <Typography
                        style={{
                          color: "white"
                        }}
                      >
                        Create FNA
                      </Typography>
                    }
                    color="secondary"
                    style={{
                      backgroundColor: "#4239d659",
                      color: "white",
                      width: "100%"
                    }}
                    onClick={props.addClicked}
                  />
                </Grid>
              </Grid>

              <Grid container>
                <Grid
                  item
                  xs={10}
                  sm={10}
                  md={10}
                  style={{ margin: "0 auto", display: "flex" }}
                >
                  <TextField
                    id="input-with-icon-textfield"
                    fullWidth
                    style={{ marginBottom: "30px" }}
                    placeholder="Description, Client or Date Created(DD/MM/YYYY)"
                    value={props.searchTerm}
                    onChange={props.handleSearch}
                    label="Search"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search />
                        </InputAdornment>
                      )
                    }}
                  />
                  <Button>Search</Button>
                </Grid>
              </Grid>
              <Table>
                <EnhancedTableHead
                  order={props.order}
                  orderBy={props.orderBy}
                  onRequestSort={(event, property) =>
                    props.handleRequestSort(event, property)
                  }
                  rowCount={props.items ? props.items.length : 0}
                  columnData={props.columnData}
                />
                <TableBody>{props.tableBody}</TableBody>
              </Table>
            </Paper>
          </CardContent>
        </Card>
      </GridItem>
    </Grid>
  );
};

export default FnaHistoryContainer;



// WEBPACK FOOTER //
// ./src/views/Fna/containers/FnaHistoryContainer.jsx